import React from "react";
import { Helmet } from "react-helmet";

const assetUrl = (assetPath) => (
  assetPath && !assetPath.startsWith("/") && !assetPath.startsWith("http")
    ? `/${assetPath}`
    : assetPath
);

export const Team = (props) => {
  return (
    <div id="team" className="text-center">
      {props.isStandalone && <Helmet htmlAttributes={{ lang: "en" }}>
        <title>Meet the Team - Immortal Computer Lab Pvt. Ltd.</title>
        <link rel="canonical" href="https://eximon.com/team/" />
        <meta charSet="utf-8" />
        <meta name="description" content="Meet the dedicated team at Immortal Computer Lab Pvt. Ltd. Learn about their expertise, roles, and contributions to delivering innovative enterprise software solutions." />

        {/* Open Graph */}
        <meta property="og:title" content="Meet the Team - Immortal Computer Lab Pvt. Ltd." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://eximon.com/team/" />
        <meta property="og:description" content="Discover the professionals behind ICL Software. Our experienced team drives innovation and delivers enterprise solutions for maritime and trade industries." />
        <meta property="og:image" content="https://eximon.com/img/apple-touch-icon.png" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Meet the Team - Immortal Computer Lab Pvt. Ltd." />
        <meta name="twitter:description" content="Get to know the ICL Software team and their expertise in delivering enterprise solutions for global trade and logistics." />
        <meta name="twitter:image" content="https://eximon.com/img/apple-touch-icon.png" />
        <script type="application/ld+json">
          {`
{
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "SoftwareApplication",
      "@id": "https://eximon.com/team",
      "url": "https://eximon.com/team",
      "name": "ICL Team - Meet the Experts Behind ICL Software Solutions",
      "applicationCategory": "BusinessApplication",
      "operatingSystem": "Web",
      "description": "Meet the dedicated team at Immortal Computer Lab Pvt. Ltd. Learn about their expertise, roles, and contributions to delivering innovative enterprise software solutions.",
      "keywords": "Team, Experts, Enterprise Software, Innovation",
      "inLanguage": "en",
      "isPartOf": {
        "@id": "https://eximon.com/"
      }
    },
    {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://eximon.com/"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Team",
          "item": "https://eximon.com/team"
        }
      ]
    }
  ]
}
`}
        </script>
      </Helmet>}

      <div className="container">
        <div className="col-md-8 col-md-offset-2 section-title">
          <h1>Meet the Team</h1>
          <h2>
            Meet our dedicated and experienced team. Learn about their skills and the roles they play.
          </h2>
        </div>
        <div id="row">
          {props.data
            ? props.data.map((d, i) => (
              <div key={`${d.name}-${i}`} className="col-md-3 col-sm-6 team">
                <div className="thumbnail">
                  {" "}
                  <img src={assetUrl(d.img)} alt={d.name} className="team-img" />
                  <div className="caption">
                    <h4>{d.name}</h4>
                    <p>{d.job}</p>
                  </div>
                </div>
              </div>
            ))
            : "loading"}
        </div>
      </div>
    </div>
  );
};
